import { observable, action } from 'mobx';
import ApiCaller from '../utils/api-caller';

class popupStore {
    // Properties

    @observable moduleNames = [
        { value: 'AMENITY', label: 'AMENITY' },
        { value: 'AMENITY_CONFIRM', label: 'AMENITY_CONFIRM' },
        { value: 'BOOKING_FACILITY', label: 'BOOKING_FACILITY' },
        { value: 'CONCIERGE', label: 'CONCIERGE' },
        { value: 'CONCIERGE_CONFIRM', label: 'CONCIERGE_CONFIRM' },
        { value: 'DEFECT_REPORT', label: 'DEFECT_REPORT' },
        { value: 'DEFECT_REPORT_CONFIRM', label: 'DEFECT_REPORT_CONFIRM' },
        { value: 'DND', label: 'DND' },
        { value: 'DND_CONFIRM', label: 'DND_CONFIRM' },
        { value: 'FRONT_OFFICE', label: 'FRONT_OFFICE' },
        { value: 'FRONT_OFFICE_CONFIRM', label: 'FRONT_OFFICE_CONFIRM' },
        { value: 'HK_SERVICE', label: 'HK_SERVICE' },
        { value: 'HK_SERVICE_CONFIRM', label: 'HK_SERVICE_CONFIRM' },
        { value: 'HOME', label: 'HOME' },
        { value: 'IN_ROOM_DINING', label: 'IN_ROOM_DINING' },
        { value: 'IN_ROOM_DINING_CONFIRM', label: 'IN_ROOM_DINING_CONFIRM' },
        { value: 'LATE_CHECKOUT', label: 'LATE_CHECKOUT' },
        { value: 'LATE_CHECKOUT_CONFIRM', label: 'LATE_CHECKOUT_CONFIRM' },
        { value: 'LAUNDRY', label: 'LAUNDRY' },
        { value: 'LAUNDRY_CONFIRM', label: 'LAUNDRY_CONFIRM' },
        { value: 'PRINT_FILE', label: 'PRINT_FILE' },
        { value: 'SHOPPING', label: 'SHOPPING' },
        { value: 'SHOPPING_CONFIRM', label: 'SHOPPING_CONFIRM' },
        { value: 'SPA', label: 'SPA' },
        { value: 'SPA_CONFIRM', label: 'SPA_CONFIRM' },
        { value: 'TRANSPORTATION', label: 'TRANSPORTATION' },
        { value: 'TV_CHANNEL', label: 'TV_CHANNEL' },
        { value: 'WAKE_UP_CALL', label: 'WAKE_UP_CALL' },
    ];

    @observable popups = [];
    @observable popup = null;
    @observable showUpdatePopupModal = false;
    @observable itemSearchValue = '';
    @observable managePopupTitle = '';
    @observable updateLoading = false;

    // Initialization

    @action initPopup() {
        this.setShowUpdatePopupModal(false);

        return ApiCaller.Popup.apiGetPopups().then(resp => {
            if (!resp.isError) {
                this.popups = resp.data;
            } else {
                this.popups = [];
            }

            this.updateLoading = false;
        });
    }

    @action initCreate(activeLanguages) {
        this.managePopupTitle = 'Add Popup';
        this.showUpdatePopupModal = true;

        this.popup = {
            'id': 0,
            'moduleName': '',
            'popupLanguages': []
        };

        activeLanguages.map(lang => {
            this.popup.popupLanguages.push({
                'id': 0,
                'popupId': 0,
                'languageId': lang.id,
                'title': '',
                'description': ''
            });

            return lang;
        });
    }

    @action initUpdate(id) {
        this.managePopupTitle = 'Update Popup';
        this.showUpdatePopupModal = true;

        return ApiCaller.Popup.GetById(id).then(resp => {
            if (!resp.isError) {
                this.popup = resp.data;
            }
        });
    }

    @action initRead(id) {
        return ApiCaller.Popup.GetById(id).then(resp => {

            if (!resp.isError) {
                this.popup = resp.data;
            }
        });
    }

    // Transaction

    @action createPopup() {
        this.updateLoading = true;
        return ApiCaller.Popup.apiCreatePopup(this.popup);
    }

    @action updatePopup() {
        this.updateLoading = true;
        return ApiCaller.Popup.apiUpdatePopup(this.popup.id, this.popup);
    }

    @action deletePopup(id) {
        return ApiCaller.Popup.Delete(id).then(() => {
            this.initPopup();
        })
    }

    @action getByModuleName(moduleName) {
        const languageCode = window.localStorage.getItem('lang') || 'en';
        return ApiCaller.Popup.GetByModuleNameAndLanguageCode(moduleName, languageCode);
    }

    @action setShowUpdatePopupModal(value) {
        this.showUpdatePopupModal = value;
    }

    @action setmoduleName(value) {
        if (this.popup) {
            this.popup.moduleName = value;
        }
    }

    @action setupdateLoading(value) {
        this.updateLoading = value;
    }

    @action settitle(langId, value) {
        if (this.popup) {
            let lang = this.popup.popupLanguages.find(fi => fi.languageId === langId);
            if (lang) {
                lang.title = value;
            }
        }
    }

    @action setdescription(langId, value) {
        if (this.popup) {
            let lang = this.popup.popupLanguages.find(fi => fi.languageId === langId);
            if (lang) {
                lang.description = value;
            }
        }
    }

    @action resetData() {
        this.popup = null;
        this.popups = [];
    }
}

export default new popupStore()
